export default "__VITE_PUBLIC_ASSET__96a79a8d__"